export const PWA_MESSAGES = {
  offline: 'You’re offline. Live data and transactions are unavailable.',
  'backend-unreachable': 'CoachHub server is temporarily unreachable. Your internet connection may still be active.',
  slow: 'The connection is slow. Some actions may take longer.',
  reconnecting: 'Reconnecting to CoachHub…',
  restored: 'Connection restored. Live data is available again.',
};
